// Advisory table shown behind the help icon of the "sample description" field:
// which descriptions suit which kind of product. Values only — the labels come
// from the same i18n keys the dropdown uses, so the two cannot drift apart.
// Order follows the business table (SMP-1576), not the enum.
const sampleDescriptionsByProductType = {
  cosmetic: [
    'anhydrousFluid',
    'anhydrousPaste',
    'biphasic',
    'emulsion',
    'gel',
    'oilyLiquid',
    'liquid',
    'oil',
    'patch',
    'pressedPowder',
    'loosePowder',
    'wipes',
    'solid',
    'propellantSpray',
    'stick',
    'fabric',
  ],
  medicalDevice: [
    'anhydrousFluid',
    'anhydrousPaste',
    'sanitaryTowelsDiapers',
    'biphasic',
    'capsule',
    'tablet',
    'materialBasedMedicalDevice',
    'emulsion',
    'gel',
    'granulate',
    'oilyLiquid',
    'liquid',
    'oil',
    'patch',
    'pressedPowder',
    'loosePowder',
    'wipes',
    'solid',
    'sponge',
    'stick',
    'fabric',
  ],
  nutraceutical: [
    'capsule',
    'tablet',
    'emulsion',
    'gel',
    'granulate',
    'oilyLiquid',
    'liquid',
    'oil',
    'solid',
  ],
};

export default sampleDescriptionsByProductType;
